import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import {SearchBoxModule} from '../../../search-box/search-box.module';
import { ProductSearchComponent } from "./product-search.component";





@NgModule({
  declarations: [ProductSearchComponent],
  imports: [
    CommonModule,
    SearchBoxModule
  ],
  exports: [
    ProductSearchComponent
  ],
})
export class ProductSearchModule { }
